import type { BadgeProps } from '@/components/ui/badge'

/** Maps free-text document statuses (purchase / dispatch / etc.) to a badge. */
export function documentStatusVariant(
  status: string | null | undefined,
): BadgeProps['variant'] {
  const s = (status ?? '').trim().toLowerCase()
  if (!s) return 'secondary'
  if (
    s.includes('cancel') ||
    s.includes('reject') ||
    s.includes('void') ||
    s.includes('fail')
  ) {
    return 'destructive'
  }
  if (
    s.includes('complete') ||
    s.includes('done') ||
    s.includes('paid') ||
    s.includes('received') ||
    s.includes('delivered') ||
    s === 'purchase' ||
    s.includes('approved') ||
    s.includes('active')
  ) {
    return 'success'
  }
  if (
    s.includes('making') ||
    s.includes('pending') ||
    s.includes('process') ||
    s.includes('draft') ||
    s.includes('hold') ||
    s.includes('progress')
  ) {
    return 'warning'
  }
  return 'info'
}
